import { valsOrNone } from '@quromedical/fhir-common';
import { compact, partial } from '@quromedical/utils';

// TODO: needs tests
type System = NonNullable<fhir4.ContactPoint['system']>;

export const createContactPoint = (
  system: System,
  rank: number,
  value?: string,
): fhir4.ContactPoint | undefined => {
  if (!value) {
    return undefined;
  }

  return {
    system,
    rank,
    value,
  };
};

export const createEmailContactPoint = partial(createContactPoint, 'email', 1);

export const createPrimaryPhoneContactPoint = partial(
  createContactPoint,
  'phone',
  1,
);

export const createSecondaryPhoneContactPoint = partial(
  createContactPoint,
  'phone',
  2,
);

type OptionalContactPoint = fhir4.ContactPoint | undefined;

export const mergeContactPoints = (
  contactPoint: OptionalContactPoint[],
): fhir4.ContactPoint[] | undefined => {
  const compacted = compact(contactPoint);
  return valsOrNone(compacted);
};
